function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import { Template } from "./util/Template";
import * as $order from "./util/Order";
import * as $array from "./util/Array";
/**
 * A base class for an amCharts theme.
 *
 * @see {@link https://www.amcharts.com/docs/v5/concepts/themes/} for more info
 * @important
 */
export var Theme = /*#__PURE__*/function () {
  function Theme(root, isReal) {
    _classCallCheck(this, Theme);
    Object.defineProperty(this, "_root", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "_rules", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: {}
    });
    this._root = root;
    if (!isReal) {
      throw new Error("You cannot use `new Class()`, instead use `Class.new()`");
    }
  }
  /**
   * Use this method to create an instance of this class.
   *
   * @see {@link https://www.amcharts.com/docs/v5/getting-started/#New_element_syntax} for more info
   * @param   root      Root element
   * @param   settings  Settings
   * @param   template  Template
   * @return            Instantiated object
   */
  _createClass(Theme, [{
    key: "setupDefaultRules",
    value: function setupDefaultRules() {}
    /**
     * Looks up the rules for a specific theme class.
     *
     * @see {@link https://www.amcharts.com/docs/v5/themes/} for more info
     * @param   themeClass Theme class
     * @return             Array<IRule<A>>
     */
  }, {
    key: "_lookupRules",
    value: function _lookupRules(themeClass) {
      return this._rules[themeClass];
    }
    /**
     * Creates a [[Template]] for specific theme class and tags.
     *
     * NOTE: the difference from `rule()` is that `ruleRaw()` does not do any
     * type checks.
     *
     * @see {@link https://www.amcharts.com/docs/v5/themes/} for more info
     * @param   themeClass Theme class
     * @param   themeTags  Theme tags
     * @return             Template
     */
  }, {
    key: "ruleRaw",
    value: function ruleRaw(themeClass) {
      var themeTags = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      var rules = this._rules[themeClass];
      if (!rules) {
        rules = this._rules[themeClass] = [];
      }
      themeTags.sort($order.compare);
      var _$array$getSortedInde = $array.getSortedIndex(rules, function (x) {
          var order = $order.compare(x.tags.length, themeTags.length);
          if (order === 0) {
            return $order.compareArray(x.tags, themeTags, $order.compare);
          } else {
            return order;
          }
        }),
        index = _$array$getSortedInde.index,
        found = _$array$getSortedInde.found;
      if (found) {
        return rules[index].template;
      } else {
        var template = Template.new({});
        rules.splice(index, 0, {
          tags: themeTags,
          template: template
        });
        return template;
      }
    }
    /**
     * Creates a [[Template]] for specific theme class and tags.
     *
     * @see {@link https://www.amcharts.com/docs/v5/themes/} for more info
     * @param   themeClass Theme class
     * @param   themeTags  Theme tags
     * @return             Template
     */
  }, {
    key: "rule",
    value: function rule(themeClass) {
      var themeTags = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      return this.ruleRaw(themeClass, themeTags);
    }
  }], [{
    key: "new",
    value: function _new(root) {
      var x = new this(root, true);
      x.setupDefaultRules();
      return x;
    }
  }]);
  return Theme;
}();